import { render, staticRenderFns } from "./EndVisitConfirmationModal.vue?vue&type=template&id=24b0c7f2&"
import script from "./EndVisitConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./EndVisitConfirmationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports